import { useCallback, useEffect, useState, useRef } from 'react';
import * as Sentry from "@sentry/react";

import {
  BoxSaldo,
  Container,
  Header,
  ProfileContainer,
  ProfileImage,
  UserName,
  DefaultHeaderContainer,
  ContainerApp,
  ProfileContainerApp,
  DefaultProfileImageApp,
} from './styles';
import { Search, User } from 'react-feather';
import Icon from '../../../assets/logo-short-cointimes.svg';
import ProfileIcon from '../../../assets/MobileMenu/profile.svg';
import CoinIcon from '../../../assets/MobileMenu/coin.svg';
import CoinOrangeIcon from '../../../assets/MobileMenu/coin-orange.svg';
import AwardIcon from '../../../assets/MobileMenu/award.svg';
import { useRouter } from 'next/router';
import { useAuth } from '../../../hooks/auth';
import LoadingUser from '../../Shimmer/LoadingUser';
import ProfileModal from '../../ProfileModal';
import Popover from '@mui/material/Popover';
import { UserBalance } from '../../../models/user';
import { useUser } from '../../../hooks/user';
import Varrow from '../../../assets/V-arrow.png';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { SearchButton, SearchContainer } from '../styles';
import SearchAutocomplete from '../../SearchAutocomplete';
import { useHome } from '../../../hooks/home';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { Option } from '../../../models/searchAutocomplete';
import Link from 'next/link';
import IndicationExt from '../../Modal/indicationExt';
import { useTranslation } from 'react-i18next';
import { isOnPopQuest } from '../../../utils/app';
import { isAppV2 } from '../../../services/versionManager';
import gaEvents from '../../../services/analytics_events';
import { t } from 'i18next';

import useMediaQuery from '@mui/material/useMediaQuery';
import { AirdropBalanceToday } from '../../../models/airdrop';
import { useAirdrop } from '../../../hooks/airdrop';

import XTimesLogoWhite from '../../../assets/Airdrop/xtimes_logo_white_no_circle.svg';

interface DefaultHeaderProps {
  name: string;
  color?: string;
  discreteBorder?: boolean;
}


  const companySlugInfo = {
    'xtimes': {
      'id': '6891bf0b-b499-4846-aa8f-da29e0ee6700',
      'title': '$XTIMES Airdrop',
      'description': t('pages.airdrop.xtimes-airdrop-description'),
      'currency': 'AIRDROP_POINT',
      'color': '#FE501C',
    },
    'kanna': {
      'id': 'befc36ba-b1a1-4c00-aa28-7045b1f8ddec',
      'title': 'Kanna Airdrop',
      'description': t('pages.airdrop.kanna-airdrop-description'),
      'currency': 'KANNA_AIRDROP_POINT',
      'color': '#2BBD04',
    },
    'coinex-cet-airdrop': {
      'id': '4775749e-7ac9-4088-9af0-8e63314f2a1c',
      'title': 'CoinEx Airdrop',
      'description': t('pages.airdrop.coinex-airdrop-description'),
      'currency': 'COINEX_AIRDROP_POINT',
      'color': '#0EAD98',
    },
  }

const LensSearch = () => {
  const router = useRouter();

  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSearchSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    const searchValue = searchInputRef.current?.value.trim();
    if (searchValue) {
      router.push('/lens/search?q=' + searchValue);
    }
  }, []);

  const handleSearchInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }, []);

  return (
    <>
      <div style={{ width: '100%', padding: '0px 24px' }}>
        <form onSubmit={handleSearchSubmit}>
          <div style={{
            display: 'flex', alignItems: 'center', border: '1px solid rgb(227, 227,227)', borderRadius: 20, backgroundColor: '#fff'
          }}>
            <input 
              ref={searchInputRef}
              type="text" 
              placeholder="Pesquise sobre criptomoedas..." 
              name="search" 
              style={{
                padding: '12px 16px', 
                width: '100%', 
                flex: '1',
                border: 'none',
                outline: 'none',
                borderRadius: '20px 0 0 20px'
              }}
              value={searchTerm}
              onChange={handleSearchInputChange}
            />
            <button 
              type="submit"
              disabled={ !searchTerm || searchTerm.trim() === ''}
              style={{
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                padding: '8px 8px',
                backgroundColor: searchTerm ? 'rgb(255, 64, 0)' : 'rgba(255, 64, 0, 0.5)',
                borderRadius: '50%',
                marginRight: '2px',
                cursor: searchTerm ? 'pointer' : 'not-allowed',
                color: '#fff',
                border: 'none',
                outline: 'none'
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

const HeaderMobile = () => {
  const { t } = useTranslation();

  const [openModalInvite, setOpenModalInvite] = useState<boolean>(false);

  const [loadingSearch, setLoadingSearch] = useState(false);
  // const [loadingSearchContainer, setLoadingSearchContainer] = useState(true);
  const [userBalance, setUserBalance] = useState<UserBalance>();
  const [isLoadingUserBalance, setIsLoadingUserBalance] = useState<boolean>(
    true
  );
  const [airdropBalanceToday, setAirdropBalanceToday] = useState<AirdropBalanceToday>({amount: '0'});
  const [isLoadingAirdropUserBalance, setIsLoadingAirdropUserBalance] = useState<boolean>(true);
  // const [width, setWidth] = useState(0);

  const isMobileResolution = useMediaQuery('(max-width: 770px)');

  const { getIsAuthenticated, user } = useAuth();
  const { getUserBalance } = useUser();
  const { getAdvertisersByString } = useHome();
  const { getAirdropBalanceToday } = useAirdrop();

  const router = useRouter();
  // const [showElement, setShowElement] = useState(true);
  const refreshBalance = useCallback(() => {
    try {
      setIsLoadingUserBalance(true);
      getUserBalance().then(userBalanceData => {
        if (userBalanceData) {
          setUserBalance(userBalanceData);
        }
        setIsLoadingUserBalance(false);
      });

      setIsLoadingAirdropUserBalance(true);
      getAirdropBalanceToday().then(airdropBalanceTodayData => {
        if (airdropBalanceTodayData) {
          setAirdropBalanceToday(airdropBalanceTodayData);
        }
        setIsLoadingAirdropUserBalance(false);
      });
    } catch (error) {
      setIsLoadingUserBalance(false);
      console.log(error);
      Sentry.captureException(error);
    }
  }, [getUserBalance]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleOnPopInAppPage = useCallback((event: any) => {
    if (isOnPopQuest(event) && event.detail.dataFromPage.quest.is_rewarded === true) {
      refreshBalance();
    }
  }, [refreshBalance]);

  useEffect(() => {
    if(!isAppV2()) {
      return;
    }

    window.addEventListener('onPopInAppPage', handleOnPopInAppPage);

    return () => {
      window.removeEventListener('onPopInAppPage', handleOnPopInAppPage);
    };
  }, [handleOnPopInAppPage]);

  useEffect(() => {
    const localToken = localStorage.getItem('@coingoback:token');

    async function getUserBalanceData() {
      try {
        const userBalanceData = await getUserBalance();
        if (userBalanceData) {
          setUserBalance(userBalanceData);
        }
        setIsLoadingUserBalance(false);

        const airdropBalanceTodayData = await getAirdropBalanceToday();
        if (airdropBalanceTodayData) {
          setAirdropBalanceToday(airdropBalanceTodayData);
        }
        setIsLoadingAirdropUserBalance(false);

        // setLoadingSearchContainer(false);
      } catch (error) {
        setIsLoadingUserBalance(false);
        // setLoadingSearchContainer(false);

        console.log(error);
        Sentry.captureException(error);
      }
    }

    if (localToken) {
      getUserBalanceData();
    }
  }, [getUserBalance]);

  useEffect(() => {
    // setWidth(window.innerWidth);

    function handleResize() {
      // setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSearch = async (inputValue: string) => {
    try {
      const response = await getAdvertisersByString(inputValue);

      return response.map(advertiser => {
        return { value: advertiser.slug, label: advertiser.name };
      });
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
    }
  };

  const searchDebounced = AwesomeDebouncePromise(handleSearch, 500);

  const handleDebounceSearch = async (inputValue: string) => {
    return await searchDebounced(inputValue);
  };

  const handleSelect = (option: Option) => {
    if (option) {
      setLoadingSearch(true);
      localStorage.setItem('@coingoback:searchLoading', 'true');

      const loadingInterval = setInterval(() => {
        const searchLoading = localStorage.getItem('@coingoback:searchLoading');
        if (!searchLoading) {
          clearInterval(loadingInterval);
          setLoadingSearch(false);
        }
      }, 200);

      router.push(`/store/${option.value}`);
    }
  };

  const HomeHeader: React.FC<React.PropsWithChildren<unknown>> = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

    const open = Boolean(anchorEl);
    const router = useRouter();

    // const showOrHide = () => setShowElement(!showElement);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleOnIndicationClick = () => {
      setOpenModalInvite(true);
      gaEvents.userGetReferralLink.emit({ page: '/home' });
    };

    const formatAmount = (v: string) => {
      const amountFormatted = v.replace(/\.0+$/, '');
      return `${amountFormatted} ${t('pages.airdrop-season.quest-rewards.airdrop-points')}`;
    };

    return (
      <>
        {openModalInvite && (
          <IndicationExt open={openModalInvite} onClose={() => {setOpenModalInvite(false)}} />
        )}
        <Header>
          <Container>
            {getIsAuthenticated() ? (
              <>
                <ProfileContainer onClick={handleClick}>
                  {user !== undefined ? (
                    <>
                      <ProfileImage />
                      <ProfileIcon />
                      <UserName>{t('hello')}, <b>{user?.name.split(' ')[0] ?? ''}</b></UserName>
                    </>
                  ) : (
                    <LoadingUser />
                  )}
                </ProfileContainer>
                <div className="balance" onClick={() => router.push('/cashback') }>
                  <div className="balance-icon">
                    <CoinIcon />
                  </div>
                  <span style={{marginRight: 7, fontWeight: 500}}>{isLoadingUserBalance ? '.......' : userBalance?.total_balance_sat_formatted.split(' ')[0]}</span>
                </div>
              </>
            ) : (
              <div className="entrarapp">
                <button
                  onClick={() => {
                    router.push('/login');
                  }}
                >
                  {t('components.header.sign-in-button')}
                </button>
                {/* <div className="divider"></div>
                <button
                  onClick={() => {
                    router.push('/signup');
                  }}
                >
                  {t('components.header.sign-up-button')}
                </button> */}
              </div>
            )}
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <ProfileModal onClose={handleClose} />
            </Popover>
          </Container>
          {/* <BoxSaldo>
            {user !== undefined && (
              <div className="today-balance" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} onClick={() => router.push('/airdrop/xtimes/season')}>
                <span>{t('components.header.today-you-earned')}</span> */}
                {/* <p><CoinOrangeIcon /> {isLoadingUserBalance ? '...' : userBalance?.total_balance_earned_today_sat_formatted.split(' ')[0]}</p> */}
                {/* <p><XTimesLogoWhite style={{color: 'black', width: 22, height: 22 }} /> {isLoadingAirdropUserBalance ? '...' : formatAmount(airdropBalanceToday?.amount)}</p>
              </div>
            )}
          </BoxSaldo> */}
          {/* { isMobileResolution
            ? <LensSearch />
            : <div className="indication" onClick={handleOnIndicationClick}>
                <AwardIcon />
                <div className='indication-content'>
                  <p>{t('components.indication-bar.refer-cointimes-and-earn')}</p>
                  <span>{t('components.indication-bar.earn-points-daily-for-the-xtimes-airdrop')}</span>
                </div>
              </div>
          } */}
          {/* <div className="mobileSearch">
            {getIsAuthenticated() ? (
              loadingSearchContainer ? (
                <LoadingSearchMobile />
              ) : (
                <SearchContainer>
                  <SearchButton style={{ border: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}>
                    {loadingSearch ? (
                      <CircularProgress size={14} className="loading" />
                    ) : (
                      <Search height={14} />
                    )}
                  </SearchButton>
                  <SearchAutocomplete
                    placeholder="Buscar lojas com cashback"
                    loadOptions={handleDebounceSearch}
                    onChange={handleSelect}
                  />
                </SearchContainer>
              )
            ) : (
              <SearchContainer>
                <SearchButton style={{ border: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}>
                  {loadingSearch ? (
                    <CircularProgress size={14} className="loading" />
                  ) : (
                    <Search height={14} />
                  )}
                </SearchButton>
                <SearchAutocomplete
                  placeholder="Buscar lojas com cashback"
                  loadOptions={handleDebounceSearch}
                  onChange={handleSelect}
                />
              </SearchContainer>
            )}
          </div> */}
        </Header>
      </>
    );
  };

  const HeaderMobileWeb: React.FC<React.PropsWithChildren<unknown>> = () => {
    const router = useRouter();

    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <ContainerApp>
        <div className="header">
          <Link href="/">
            <Icon className="icon" />
          </Link>
          <div className="mobileSearch">
            <SearchContainer $variant="filled">
              <SearchButton $transparent>
                {loadingSearch ? (
                  <CircularProgress size={14} className="loading" />
                ) : (
                  <Search height={14} />
                )}
              </SearchButton>
              <SearchAutocomplete
                placeholder="Buscar lojas com cashback"
                loadOptions={handleDebounceSearch}
                onChange={handleSelect}
              />
            </SearchContainer>
          </div>
          {getIsAuthenticated() ? (
            <>
              <ProfileContainerApp onClick={handleClick}>
                <DefaultProfileImageApp>
                  <User />
                </DefaultProfileImageApp>
              </ProfileContainerApp>
            </>
          ) : (
            <div className="entrarapp">
              <button
                onClick={() => {
                  router.push('/login');
                }}
              >
                Login
              </button>
              <div className="divider"></div>
              {/* <button
                onClick={() => {
                  router.push('/signup');
                }}
              >
                Cadastro
              </button> */}
            </div>
          )}
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <ProfileModal onClose={handleClose} />
          </Popover>
        </div>
      </ContainerApp>
    );
  };

  const DefaultHeader: React.FC<React.PropsWithChildren<DefaultHeaderProps>> = ({ name, color, discreteBorder = false }) => {
    const { back } = useRouter();

    return (
      <DefaultHeaderContainer $color={color} $border={discreteBorder}>
        <button onClick={back} style={{padding: 0}}>
          <img src={Varrow.src} alt="voltar" />
        </button>
        <h1 style={{fontSize: 'calc(18px + 0.390625vw)'}}>{name}</h1>
        <div />
      </DefaultHeaderContainer>
    );
  };

  const DynamicallyHeader = () => {
    const { pathname } = useRouter();

    if (pathname === '/home') {
      return <HomeHeader />;
    } else if (pathname.includes('/news')) {
      return <DefaultHeader name="Notícias" />;
    } else if (pathname.includes('/store')) {
      return <DefaultHeader name="Ganhe bitcoin" />;
    } else if (pathname === '/cashback') {
      return <DefaultHeader name={t('pages.cashback.title')} />;
    } else if (pathname === '/cashout') {
      return <DefaultHeader name={t('pages.cashout.title')} />;
    } else if (pathname.includes('/recommendation')) {
      return <DefaultHeader name={t('pages.recommendation.title')} />;
    } else if (pathname.includes('/quests')) {
      return <DefaultHeader name={t('pages.quests.title')} />;
    } else if (pathname.includes('/read-to-earn')) {
      return <DefaultHeader name="Read to Earn" />;
    } else if (pathname.includes('/external-wallets')) {
      return <DefaultHeader name={t('pages.external-wallets.title')} />;
    } else if (pathname.startsWith('/airdrop/[slug]/season')) {
      return <></>
    } else if (pathname.startsWith('/airdrop')) {
      const { slug } = router.query;
      const title = companySlugInfo[slug as string]?.title || 'Airdrop';
      return <DefaultHeader name={title} discreteBorder />;
    } else if (pathname === '/help') {
      return <DefaultHeader name="Ajuda" />;
    }
    else if (pathname === '/market') {
      return <DefaultHeader name="Mercado" />;
    } else if (pathname === '/discover') {
      return <DefaultHeader name="Descobrir" />;
    } else if (pathname === '/weare') {
      return <HeaderMobileWeb />;
    } else if (pathname === '/') {
      return <HeaderMobileWeb />;
    } else {
      return <></>;
    }
  };

  return <DynamicallyHeader />;
};

export default HeaderMobile;
